import { ListContextProvider, useList, useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Mapping, MappingItem } from 'types/embedded/gatewayRule';

import { GatewayRuleMappingDatagrid } from './GatewayRuleMappingDatagrid/GatewayRuleMappingDatagrid';
import { GatewayRuleMappingInfo } from './GatewayRuleMappingInfo/GatewayRuleMappingInfo';

type Props = {
  actionsSlot?: React.ReactNode;
  children?: React.ReactNode;
  enableAdditionalFields?: boolean;
};

export const GatewayRuleMapping: React.FC<Props> = ({
  actionsSlot,
  children,
  enableAdditionalFields,
}) => {
  const mappingRecord = useRecordContext<Mapping>();

  const listContext = useList<MappingItem>({
    data: (mappingRecord?.mappingItems ?? []) as MappingItem[],
  });

  return (
    <ListContextProvider value={listContext}>
      <Box mb={3}>
        <GatewayRuleMappingInfo
          actionsSlot={actionsSlot}
          enableAdditionalFields={enableAdditionalFields}
        />
        <GatewayRuleMappingDatagrid>{children}</GatewayRuleMappingDatagrid>
      </Box>
    </ListContextProvider>
  );
};
